import { Component, OnInit, Output, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss']
})
export class DeleteButtonComponent implements OnInit {

  @Output() onClick: Subject<void> = new Subject<void>()
  @Input() tooltipContent: string

  constructor() { }

  ngOnInit(): void {
  }

}
